
import { defineComponent } from 'vue'

// mixins
import ActiveUserMixin from '~/mixins/activeUserMixin'
import AuthMixin from '~/mixins/authMixin'

import { getDefaultAvatar } from '~/utils/ui'

export default defineComponent({
  name: 'UserMenu',
  mixins: [ActiveUserMixin, AuthMixin],
  props: {
    isCollapsed: {
      type: Boolean,
      default: false
    },
    hoverBgColor: {
      type: String,
      default: 'hover:bg-ink-300'
    }
  },
  data() {
    return {
      showTooltip: false
    }
  },
  methods: {
    getDefaultAvatar
  },
  mounted(): void {
    const username = this.$refs.username as Element
    if (username) {
      this.showTooltip = username.scrollWidth >= username.clientWidth
    }
  }
})
